module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_darkbrown.7121df82.png";